import { ref, watch, computed } from '@vue/composition-api'
import { useToast } from "vue-toastification/composition"
import i18n from "@/libs/i18n"
import { getCourses } from '@/composables/courseService'
import { getTeachers } from '@/composables/teacherService'
import { getLessons } from '@/composables/lessonService' 
import { existsModule } from '@/hooks/modulesUtils'

export default function lessonListQuery() {
    const toast = useToast()
    const refDataListTable = ref(null)
    const perPage = ref(10)
    const totalData = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const teachersOptions = ref([])
    const coursesOptions = ref([])
    const teacherFilter = ref(null)
    const courseFilter = ref(null)

    const tableColumns = ref([
        { key: 'datetime', label: i18n.t('Fecha y hora'), sortable: true },
        { key: 'course', label: i18n.t('Course'), sortable: true },
        { key: 'is_extra', label: i18n.t('Clase extra') },
        { key: 'observations', label: i18n.t('Observations') },
        { key: 'actions', label: i18n.t('Actions') }
    ])

    const dataMeta = computed(() => {
        const localItemsCount = refDataListTable.value ? refDataListTable.value.localItems.length: 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalData.value,
        }
    });

    const refetchData = function() {
        refDataListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery, teacherFilter, courseFilter], () => {
        refetchData()
    })

    const fetchData = async function(ctx, callback) {
        let response = await getLessons({
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            teacher: teacherFilter.value,
            course: courseFilter.value
        })
        const { lessons, total } = response.data

        totalData.value = total
        return (lessons)
    }

    const fetchCourses = async function (query) {
        let response = await getCourses({q:query})
        coursesOptions.value = response
    } 

    const fetchTeachers = async function (query) {
        if (existsModule('Academy')) {
            let response = await getTeachers({q:query})
            tableColumns.value.push({ key: 'teacher', label: i18n.t('Teacher'), sortable: true })
            teachersOptions.value = response.data.teachers
        }
    }

    if (existsModule('Academy')) tableColumns.value.push({ key: 'classroom', label: 'Aula'} )

    return {
        fetchData,
        fetchCourses,
        fetchTeachers,
        tableColumns,
        perPage,
        currentPage,
        totalData,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refDataListTable,
        refetchData,
        teacherFilter,
        teachersOptions,
        coursesOptions,
        courseFilter
    }
}
